import "../Dashboard/Dashboard.css";
import { Link } from "react-router-dom";
import BackButton from "../Goback/GoBack";
import TeacherTable from "../Dashboard/TeacherTable";
import RoleGuard from "../../../auth/RoleGuard";

export const SchoolAdminTeacher = () => {
  return (
    <>
      <div className="container-fluid p-0">
        <div className="p-0" id="">
          <div className="p-0" id="mainContent">
            <section>
              <div className="container-fluid">
                <div className="row mb-4 align-items-center">
                  <div className="col-12 col-md-12">
                    <BackButton />
                  </div>
                  <div className="col-12 col-md-4 my-2">
                    <p className="tchrdashboard-cmntitl mb-0">All Teachers</p>
                  </div>
                  <RoleGuard permission="teachers_create">
                    <div className="col-12 col-md-8 text-md-end my-2">
                      <Link
                        to="/school-admin/teachers/create"
                        className="dashboard-btn"
                      >
                        Add Teacher
                      </Link>
                    </div>
                  </RoleGuard>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <TeacherTable />
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </>
  );
};
